import { Link } from 'react-router-dom';
import type { ProgressItem } from '../api/progress';
import type { MovieListItem } from '../api/library';

interface Props {
  progress: ProgressItem[];
  byId: Map<string, MovieListItem>;
}

export function ContinueWatchingRow({ progress, byId }: Props) {
  const items = progress
    .map((p) => ({ p, m: byId.get(p.mediaId) }))
    .filter((x): x is { p: ProgressItem; m: MovieListItem } => !!x.m);

  if (items.length === 0) return null;

  return (
    <section className="mb-10">
      <h2 className="mb-3 text-lg font-semibold">Continue watching</h2>
      <div className="-mx-4 flex gap-4 overflow-x-auto px-4 pb-2">
        {items.map(({ p, m }) => {
          const pct = p.durationSec ? Math.min(100, Math.round((p.positionSec / p.durationSec) * 100)) : 0;
          return (
            <Link
              key={m.id}
              to={`/movies/${m.id}`}
              className="block w-56 flex-shrink-0 group"
            >
              <div className="relative aspect-video w-full overflow-hidden rounded-2xl bg-surface-2 shadow-sm">
                {m.posterUrl ? (
                  <img src={m.posterUrl} alt={m.title} className="h-full w-full object-cover" loading="lazy" />
                ) : (
                  <div className="flex h-full w-full items-center justify-center text-text-secondary text-sm">No poster</div>
                )}
                <div className="absolute inset-x-0 bottom-0 h-1 bg-base-300/60">
                  <div className="h-full bg-primary" style={{ width: `${pct}%` }} />
                </div>
              </div>
              <div className="mt-2 px-1">
                <div className="truncate text-sm font-medium">{m.title}</div>
                <div className="text-xs text-text-secondary">{pct}% watched</div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
